import * as react_components from "../reactcomponent.js"
import { getGlobalSettings } from "../settings.js"
import React from "react";
interface ITranslationsEditor {
    contextVariables: any;
    onClose();
    onSave(result: string)
}

export class TranslationsEditor extends React.Component<ITranslationsEditor, any>{
    constructor(props, context) {
        super(props, context)
        this.state = { basePath: getGlobalSettings().GetSettings().INNO_BASE_PATH };
    }

    handleSelectionChanged = (selectedItem) => {
        this.setState({ selectedItem: selectedItem })
    }
    handleOkay = () => {
        if (this.state.selectedItem) {
            this.props.onSave(this.state.selectedItem);
        } else {
            this.props.onClose();
        }
    }
    render() {
        return (<react_components.BasicDialog width="80%" onSave={this.handleOkay} title="Select service" onClose={this.props.onClose}>
            <a href={this.props.contextVariables.INNO_BASE_PATH + "TranslationsEditor"} target="_blank">Manage translations</a>
            <div style={{ height: "600px", overflow: "hidden" }}>
                <KendoTranslationsTable onSelectionChanged={this.handleSelectionChanged} basePath={this.state.basePath} />
            </div>
        </react_components.BasicDialog>
        );
    }
};


class KendoTranslationsTable extends React.Component<any, any>{
    private grid: any;
    constructor(props: any, context: any) {
        super(props, context)
    }

    handleSelectionChange = () => {
        var selectedItem = this.grid.dataItem(this.grid.select());
        if (this.props.onSelectionChanged) {
            this.props.onSelectionChanged(selectedItem.Key);
        }
    }
    componentDidMount() {

        let that = this;
        let $rootNode = $(this.refs.grid);
        var filterTemplate = function (args) {
            args.element.css("width", "90%").addClass("k-textbox").keydown(function (e) {
                setTimeout(function () {
                    $(e.target).trigger("change");
                });
            });
        }
        var gridOptions = ({
            selectable: 'row',
            columns: [
                {
                    field: 'Key', title: 'Key', filterable: {
                        cell: {
                            operator: "contains",
                            template: filterTemplate,
                            showOperators: false
                        }
                    }
                },
                {
                    field: 'Base', title: 'Base translation', filterable: {
                        cell: {
                            operator: "contains",
                            template: filterTemplate,
                            showOperators: false
                        }
                    }
                },
                {
                    field: 'Custom', title: 'Custom translation', filterable: {
                        cell: {
                            operator: "contains",
                            template: filterTemplate,
                            showOperators: false
                        }
                    }
                }
            ],
            filterable: { mode: 'row' },
            change: this.handleSelectionChange,
            sortable: true,
            pageable: {
                refresh: true
            },
            batch: true,
            pageSize: 12,
            type: 'aspnetmvc-ajax',
            dataSource: new kendo.data.DataSource({
                type: 'aspnetmvc-ajax',
                transport: {
                    read: {
                        url: this.props.basePath + 'StatisticTranslations/GetTranslations',
                        dataType: 'json',
                        type: 'GET'
                    },
                    parameterMap: function (options) {
                        return JSON.stringify(options);
                    }
                },
                page: 1,
                batch: true,
                pageSize: 12,
                schema: {
                    data: 'Data',
                    total: (response: any) => {
                        return response.Total; // total is returned in the "total" field of the response
                    },
                    model: {
                        id: 'Key',
                        fields: {
                            Key: {
                                editable: true,
                                validation: {
                                    required: true,
                                    keyvalidation: (input: any) => {
                                        if (input.is("[name='Key']") && input.val() !== '') {
                                            let exists = false;
                                            input.attr('data-keyvalidation-msg', 'Key may only be assigned once.');

                                            return !exists;
                                        }

                                        return true;
                                    }
                                }
                            },
                            Bases: { editable: true, validation: { required: false } },
                            Customs: { editable: true, validation: { required: false } }
                        }
                    }
                }
            })
        } as any);
        var grid = $rootNode.kendoGrid(gridOptions);

        this.grid = grid.data("kendoGrid");
    }
    componentWillUnmount() {
        kendo.destroy(this.grid.element);
    }

    render() {
        return (
            <div style={{ height: "100%" }} ref="grid"></div>
        )
    }
}